import { Link } from "react-router-dom";

const footerColumns = [
  {
    title: "内容频道",
    links: [
      { label: "娱乐资讯", to: "/news" },
      { label: "视频专区", to: "/video" },
      { label: "游戏攻略", to: "/game" },
    ],
  },
  {
    title: "社区互动",
    links: [
      { label: "论坛首页", to: "/forum" },
      { label: "影视交流", to: "/forum/film" },
      { label: "游戏天地", to: "/forum/game" },
    ],
  },
  {
    title: "关于我们",
    links: [
      { label: "网站介绍", to: "/about" },
      { label: "联系我们", to: "/contact" },
      { label: "站内搜索", to: "/search" },
    ],
  },
];

const socials = [
  { icon: "ri-weibo-fill", label: "微博" },
  { icon: "ri-wechat-fill", label: "微信" },
  { icon: "ri-bilibili-fill", label: "哔哩哔哩" },
  { icon: "ri-youtube-fill", label: "视频号" },
];

export default function SiteFooter() {
  return (
    <footer className="mt-16 border-t border-background-200 bg-secondary-100">
      <div className="mx-auto w-full px-4 py-12 md:px-6 md:py-14">
        <div className="flex flex-col gap-10 lg:flex-row lg:justify-between">
          <div className="max-w-sm">
            <Link to="/" className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-fire-fill text-lg" aria-hidden="true"></i>
              </span>
              <span className="font-brand text-2xl text-foreground-950">天天干天天干</span>
            </Link>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600">
              天天干天天干是面向广大娱乐爱好者的综合门户，汇集影视、音乐、游戏等多元内容，
              提供资讯阅读、视频浏览与社区互动的一站式体验。
            </p>
            <div className="mt-5 flex items-center gap-2">
              {socials.map((s) => (
                <span
                  key={s.label}
                  title={s.label}
                  className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-full bg-background-50 text-foreground-600 transition-colors hover:bg-primary-500 hover:text-background-50"
                >
                  <i className={`${s.icon} text-lg`} aria-hidden="true"></i>
                </span>
              ))}
            </div>
          </div>

          <div className="grid grid-cols-2 gap-8 sm:grid-cols-3 lg:gap-16">
            {footerColumns.map((col) => (
              <div key={col.title}>
                <h4 className="text-sm font-semibold text-foreground-950">{col.title}</h4>
                <ul className="mt-4 space-y-3">
                  {col.links.map((link) => (
                    <li key={link.label}>
                      <Link
                        to={link.to}
                        className="text-sm text-foreground-600 transition-colors hover:text-primary-600"
                      >
                        {link.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-background-300 pt-6 text-xs text-foreground-500 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2026 天天干天天干 · 本站内容均为演示用途</p>
          <p>内容仅供学习交流，请勿用于商业用途</p>
        </div>
      </div>
    </footer>
  );
}